/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetCalendarDto
 */
export interface GetCalendarDto {
    /**
     * 
     * @type {string}
     * @memberof GetCalendarDto
     */
    id: string;
    /**
     * 
     * @type {Date}
     * @memberof GetCalendarDto
     */
    dailyDate: Date;
}

/**
 * Check if a given object implements the GetCalendarDto interface.
 */
export function instanceOfGetCalendarDto(value: object): value is GetCalendarDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('dailyDate' in value) || value['dailyDate'] === undefined) return false;
    return true;
}

export function GetCalendarDtoFromJSON(json: any): GetCalendarDto {
    return GetCalendarDtoFromJSONTyped(json, false);
}

export function GetCalendarDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCalendarDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'dailyDate': (new Date(json['dailyDate'])),
    };
}

export function GetCalendarDtoToJSON(value?: GetCalendarDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'dailyDate': ((value['dailyDate']).toISOString()),
    };
}

